// Determines if the perceived screen width exceeds a threshold.
// Bootstrap breakpoints look at exact pixel numbers, but screens
// of different sizes with same pixels still display things differently.
// Ex: Things look more squished on a 14" screen at 1080p than on a 24" at 1080p.
// So need breakpoints that are aware of this.
export default {
  data() {
    return { isWide: (window.innerWidth / window.devicePixelRatio) >= 1200 };
  },
  created() {
    this.onResize = () => {
      this.isWide = (window.innerWidth / window.devicePixelRatio) >= 1200;
    };
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() { window.removeEventListener('resize', this.onResize); },
};
